import type { ExtendedAdsQueryVariables } from '../types/extendedAdsQueryVariables';

export const removeExtraParamsFromAdsQueryVariables = (queryVariables: Partial<ExtendedAdsQueryVariables>) => {
    const {
        orderBy,
        places,
        offset,
        limit,
        googlePlacesAutocompleteSearch,
        placesSource,
        ...queryVariablesWithoutExtraParams
    } = queryVariables;

    return queryVariablesWithoutExtraParams;
};
